/**
 * Parses a salary string, removing commas and converting to a float.
 * @param {string} value - The salary value as a string.
 * @returns {number} - The parsed salary as a float or 0 if invalid.
 */
export const parseSalary = (value) => {
  return parseFloat(value.split(',').join('')) || 0;
};
